// export * from "./TestClass"
import { TestClass } from "./TestClass"
import { TestDashboard } from "./TestDashboard";

export var testing = {
    TestClass,
    TestDashboard,
};